import React from "react";

/** One number in a page's stat tray (`grid gap-1 p-1 rounded-[18px] bg-[var(--surface-2)]`):
    a label, the value, a caption (in `tone` when it carries a verdict), and an optional trend. */
export function StatTile({ label, value, sub, tone = "", children }: {
  label: React.ReactNode;
  value: React.ReactNode;
  sub?: React.ReactNode;
  tone?: string;
  children?: React.ReactNode;
}) {
  return (
    <div className="rounded-[14px] ring-1 ring-[var(--hairline)] bg-[var(--surface)] shadow-lift px-4 py-3.5 min-w-0">
      <div className="section-label">{label}</div>
      {/* Two tiles to a row on a phone: the trend drops under the number and the caption wraps rather than both squeezing */}
      <div className="flex flex-wrap items-end justify-between gap-x-2 gap-y-1 mt-1">
        <div className="min-w-0">
          <div className="text-[18px] font-semibold tracking-[-0.02em] text-[var(--text-primary)] tabular-nums leading-tight">{value}</div>
          {sub && <div className={`text-[11.5px] leading-[1.45] mt-[2px] ${tone || "text-[var(--text-tertiary)]"}`}>{sub}</div>}
        </div>
        {children}
      </div>
    </div>
  );
}
